import { useGetByTenantCounterpartyCounterpartyidsQuery } from 'api/rtk-api'

import { TENANT } from '../../../const'
import { TaxReportsTemplate } from '../templates'

export const TaxReportsPage = () => {
  const { isLoading } = useGetByTenantCounterpartyCounterpartyidsQuery({
    tenant: TENANT
  })

  return <TaxReportsTemplate isLoading={isLoading} />
}
